<div
  class="sub-header"
>
  <div class="sub-header-row px-1 py-2">
    <div class="row">
      <div class="col">
        <app-breadcrumb></app-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <a
          [class]="ButtonType.Primary | buttontypepipe"
          class="btn-sm btn"
          (click)="triggerAction('contractCreatePush')"
          translate
        >
          GLOBAL_BTN_SAVE
        </a>
        <a
          [class]="ButtonType.Light | buttontypepipe"
          class="btn-sm btn"
          (click)="triggerAction('contractList')"
          translate
        >
          GLOBAL_BTN_CANCEL
        </a>
      </div>
    </div>
  </div>
</div>
